import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PageShell } from '../components/PageShell';
import { ChapterRail } from '../components/products/ChapterRail';
import { ProductCrossSell } from '../components/products/ProductCrossSell';
import { ProductHero } from '../components/products/ProductHero';
import { ProductScrollStory } from '../components/products/ProductScrollStory';
import { getProduct, getSiblings } from '../data/products';

/**
 * One layout, three products. Only the accent, the copy, and the centrepiece
 * change — so the pages read as siblings and cannot drift apart.
 */
export function ProductPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const product = slug ? getProduct(slug) : undefined;
  if (!product) {
    return <Navigate to="/" replace data-id="element-1064" data-mp="1qbkdxfh0du5b" />;
  }
  return <PageShell data-id="element-1065" data-mp="1qaiyyzwvgnib">
      <ChapterRail product={product} data-id="element-1066" data-mp="1q9zjrqylwd7z" />
      <ProductHero product={product} data-id="element-1067" data-mp="1lchj0nuqt4b2" />
      <ProductScrollStory product={product} data-id="element-1068" data-mp="1lbfxtqk0j1fm" />

      <section className="bg-paper px-5 pb-20 md:px-10 lg:pl-20" data-id="element-1069" data-mp="1letxgr1akwjd">
        <p className="mx-auto max-w-shell border-t border-ink/15 pt-6 text-xs font-bold leading-relaxed text-ink/55" data-id="element-1070" data-mp="1cnm2xwwpbjf0">
          {product.disclosure}
        </p>
      </section>

      <ProductCrossSell siblings={getSiblings(product.slug)} data-id="element-1071" data-mp="1lpvdgmryzcse" />
    </PageShell>;
}